import { Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { ToastbarContext } from '../../App';
import {
  Column,
  EditDrawer,
  HorizontalFormInput,
  KeyValueLabel,
  Row,
  Spacer,
} from '../../components';
import { MutationStatus, useAppStorage, useMutation, useObservable } from '@aesop-fables/scrinium';
import { Toast } from '../../models/Toast';
import { TeamCompartments, teamStorageKey } from '../../data/team';
import { TeamData } from '../../models/TeamData';
import { UpdateTeamData } from '../../data/team/mutations';
import { RoleInfoCard } from '../multitier/AdminInfo';

const AboutYourTeamCard: React.FC = () => {
  const appStorage = useAppStorage();
  const teamDataCache = appStorage.retrieve<TeamCompartments>(teamStorageKey);
  const teamName = useObservable(teamDataCache.observe$<TeamData>('team'))?.name ?? '';
  const updateTeamData = useMutation(new UpdateTeamData());
  const { setToast } = useContext(ToastbarContext);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    if (updateTeamData?.error?.message.includes('500')) {
      setToast(
        new Toast({
          message: 'Team name is already taken. Please use a unique name.',
          severity: 'error',
          open: true,
          autoHideDuration: 3000,
        }),
      );
    } else if (updateTeamData.status === MutationStatus.Complete) {
      setToast(
        new Toast({
          message: 'Team info updated!',
          severity: 'success',
          open: true,
          autoHideDuration: 3000,
        }),
      );
    }
  }, [setToast, updateTeamData?.error?.message, updateTeamData.status]);

  const onSubmit = (values: TeamData) => {
    const { name } = values;
    try {
      updateTeamData.action({ name });
    } catch (err) {
      console.error(err);
    }
    setDrawerOpen(false);
  };

  return (
    <>
      <Row style={{ justifyContent: 'space-between' }}>
        <Typography variant='subtitle1' color='secondary.main'>
          About your team
        </Typography>
      </Row>
      <Spacer height='xs' />

      <RoleInfoCard setDrawerOpen={setDrawerOpen} editable={true}>
        <KeyValueLabel keyString='Name' value={teamName} />
        <EditDrawer
          title='Edit team'
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
          onSubmit={onSubmit}>
          <Column
            style={{
              width: '90%',
            }}>
            <HorizontalFormInput<any>
              fieldName='name'
              label='Name'
              initialValue={teamName}
              labelStyle={{ flex: '2 0 10px', marginTop: '10px' }}
              inputStyle={{ flex: '3 0 10px' }}
              textSize='small'
              rightAlignedKey
              autoFocus
              required
            />
          </Column>
        </EditDrawer>
      </RoleInfoCard>
    </>
  );
};

export default AboutYourTeamCard;
